import { PanelLeft } from 'lucide-react';

import { ContentPhonePreview } from './ContentPhonePreview';
import { useTranslation } from 'react-i18next';

interface SetupPreviewPaneProps {
  caption: string;
  mediaAssetId?: string;
  mediaType?: 'image' | 'video';
  date: Date;
  title?: string;
  platform: string | undefined;
}

const formatDate = (date: Date): string =>
  date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

export const SetupPreviewPane = ({
  caption,
  mediaAssetId,
  mediaType,
  date,
  title,
  platform,
}: SetupPreviewPaneProps) => {
  const { t } = useTranslation('contentTest');
  return (
    <div className="flex h-full flex-col bg-gray-50 dark:bg-surface">
      <div className="flex h-16 shrink-0 items-center gap-2 border-b border-border bg-background px-6">
        <PanelLeft size={18} aria-hidden />
        <span className="text-sm font-medium text-foreground">
          {title?.trim() ? title.trim() : t('contentTest.setupPreviewPane.contentTest')} -{' '}
          {formatDate(date)}
        </span>
      </div>
      <div className="flex min-h-0 flex-1 flex-col items-center overflow-y-auto p-8">
        {/* Auto top/bottom margins center the preview when it fits and collapse to
          0 when it overflows, so the top stays reachable on short screens
          (justify-content: center would push the top above the scroll origin). */}
        <div className="my-auto">
          <ContentPhonePreview
            caption={caption}
            mediaAssetId={mediaAssetId}
            mediaType={mediaType}
            platform={platform}
          />
        </div>
      </div>
    </div>
  );
};

SetupPreviewPane.displayName = 'SetupPreviewPane';
